function openDrawer(fromBadges) {
    const overlay = document.querySelector(".js-drawer-modal-overlay");
    const drawer = document.querySelector(".js-drawer-tabla-nutricional");
    if (!overlay || !drawer) return;

    overlay.classList.remove("drawer-modal-overlay__hidden");
    drawer.classList.remove("drawer-tabla-nutricional__hidden");
    document.body.classList.add("lock");

    var certsBlock = drawer.querySelector(".drawer-tabla-nutricional__certificaciones");
    if (certsBlock) {
        certsBlock.style.display = fromBadges ? "" : "none";
    }

    window._conv_q = window._conv_q || []; 
    _conv_q.push(["triggerConversion", "1004113986"]);

    const variantMedia = document.querySelector(".js-tabla-nutricional-by-variant");
    const drawerSlot = drawer.querySelector("[data-tabla-nutricional-by-variant]");

    // Cuando el metafield viene por variante, el re-render parcial puede ocurrir
    // justo después del cambio de variante. Si el drawer se abre "demasiado rápido",
    // copiamos con un par de reintentos hasta que coincida el variant-id.
    function syncDrawerMedia(attempt) {
        attempt = attempt || 0;
        const vm = document.querySelector(".js-tabla-nutricional-by-variant");
        const slot = drawer.querySelector("[data-tabla-nutricional-by-variant]");
        if (!vm || !slot) return;

        const expected = window.__tablaNutricionalCurrentVariantId || null;
        const current = vm.getAttribute("data-tabla-nutricional-variant-id") || null;

        if (expected && current && expected !== current && attempt < 8) {
            setTimeout(function () { syncDrawerMedia(attempt + 1); }, 80);
            return;
        }

        slot.innerHTML = vm.innerHTML;
        if (current) slot.setAttribute("data-tabla-nutricional-variant-id", current);
    }

    if (variantMedia && drawerSlot) {
        syncDrawerMedia(0);
    }
}

function closeDrawer() {
    const overlay = document.querySelector(".js-drawer-modal-overlay");
    const drawer = document.querySelector(".js-drawer-tabla-nutricional");
    if (!overlay || !drawer) return;

    overlay.classList.add("drawer-modal-overlay__hidden");
    drawer.classList.add("drawer-tabla-nutricional__hidden");
    document.body.classList.remove("lock");

    window._conv_q = window._conv_q || [];  
    _conv_q.push(["triggerConversion", "1004113987"]);
}

document.addEventListener("click", function(e) {
    const trigger = e.target.closest(".js-tabla-nutricional-button");
    if (trigger) {
        openDrawer();
        return;
    }

    const trustBadgesTrigger = e.target.closest(".js-open-drawer-tabla-nutricional");
    if (trustBadgesTrigger) {
        console.log("Goal - Click Badges");
        window._conv_q = window._conv_q || [];
        _conv_q.push(["triggerConversion", "1004115609"]);
        openDrawer(true);
        return;
    }

    const closeBtn = e.target.closest(".js-drawer-tabla-nutricional-close-button");
    if (closeBtn) {
        closeDrawer();
        return;
    }

    if (e.target.matches(".js-drawer-modal-overlay")) {
        closeDrawer();
    }
});

document.addEventListener("keydown", function(e) {
    const trustBadges = e.target.closest(".js-open-drawer-tabla-nutricional");
    if (trustBadges && (e.key === "Enter" || e.key === " ")) {
        e.preventDefault();
        console.log("Goal - Click Badges");
        window._conv_q = window._conv_q || [];
        _conv_q.push(["triggerConversion", "1004115609"]);
        openDrawer(true);
    }
});

// Track de variante activa para sincronizar metafields "por variante" en el drawer.
// Se usa solo para el retry de sync del contenido.
document.addEventListener("variant:change", function (event) {
    try {
        if (event && event.detail && event.detail.variant && event.detail.variant.id) {
            window.__tablaNutricionalCurrentVariantId = String(event.detail.variant.id);
        }
    } catch (e) {}
});